import { render } from "./ErrorPage.vue?vue&type=template&id=564cfa34"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"

import "./ErrorPage.vue?vue&type=style&index=0&id=564cfa34&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__